/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ t: NonNullable<unknown> }} Heating_Curve_Reduced_TextInputs */

const fr_heating_curve_reduced_text = /** @type {((inputs: Heating_Curve_Reduced_TextInputs) => LocalizedString) & { parts: (inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Heating_Curve_Reduced_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`En période d'inoccupation, un réduit de ${i?.t}°C est appliqué à la consigne de la loi d'eau`)
		}),
		{
			parts: /** @type {(inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "En période d'inoccupation, " }, { type: "markup-start", name: "trigger", options: {}, attributes: {} }, { type: "text", value: "un réduit de " }, { type: "text", value: String(i?.t) }, { type: "text", value: "°C" }, { type: "markup-end", name: "trigger", options: {}, attributes: {} }, { type: "text", value: " est appliqué à la consigne de la loi d'eau" }])
			})
		}
	)
);

const en_heating_curve_reduced_text = /** @type {((inputs: Heating_Curve_Reduced_TextInputs) => LocalizedString) & { parts: (inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Heating_Curve_Reduced_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`During unoccupation, a reduction of ${i?.t}°C is applied to the water law setpoint`)
		}),
		{
			parts: /** @type {(inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "During unoccupation, " }, { type: "markup-start", name: "trigger", options: {}, attributes: {} }, { type: "text", value: "a reduction of " }, { type: "text", value: String(i?.t) }, { type: "text", value: "°C" }, { type: "markup-end", name: "trigger", options: {}, attributes: {} }, { type: "text", value: " is applied to the water law setpoint" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "During unoccupation, a reduction of {t}°C is applied to the water law setpoint" |
*
* @param {Heating_Curve_Reduced_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_reduced_text = /** @type {((inputs: Heating_Curve_Reduced_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Heating_Curve_Reduced_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Heating_Curve_Reduced_TextInputs, { locale?: "fr" | "en" }, { trigger: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Heating_Curve_Reduced_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_heating_curve_reduced_text(inputs)
			return fr_heating_curve_reduced_text(inputs)
		}),
		{
			parts: /** @type {(inputs: Heating_Curve_Reduced_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[] }} */ (en_heating_curve_reduced_text).parts?.(inputs) ?? [{ type: "text", value: en_heating_curve_reduced_text(inputs) }]
				return /** @type {{ parts?: (inputs: Heating_Curve_Reduced_TextInputs) => import('../runtime.js').MessagePart[] }} */ (fr_heating_curve_reduced_text).parts?.(inputs) ?? [{ type: "text", value: fr_heating_curve_reduced_text(inputs) }]
			})
		}
	)
);